export default {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-speedometer",
      badge: {
        variant: "primary",
        text: "HOME"
      }
    },
    {
      name: "Daily Receiving",
      url: "/daily-receiving",
      icon: "icon-chart"
    },
    {
      name: "Map Overview",
      url: "/base/Map",
      icon: "icon-map"
    },
    {
      name: "Backlog By Location",
      url: "/base/backlog-by-location",
      icon: "icon-layers"
    },
    {
      title: true,
      name: "TECHNICAL STATISTICS",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    },
    {
      name: "Active Backlog",
      url: "/base/Backlog",
      icon: "icon-layers"
    },
    {
      name: "Analytics By Model",
      url: "/analyticsByModel",
      icon: "icon-chart"
    },
    // {
    //   name: "Regional Analytics",
    //   url: "/base/SubDivision",
    //   icon: "icon-chart"
    // },
    // {
    //   name: 'Shipped',
    //   url: '/theme/typography',
    //   icon: 'icon-logout'
    // },
    // {
    //   name: 'Received',
    //   url: '/theme/typography',
    //   icon: 'icon-login'
    // },
    {
      name: "Beyond Economical Repair",
      url: "/base/BER",
      icon: "icon-chart"
    },
    {
      name: "End Of Life",
      url: "/base/EOL",
      icon: "icon-chart"
    },
    // {
    //   name: "No Trouble Found",
    //   url: "/base/NTF",
    //   icon: "icon-chart"
    // },
    {
      name: "Under Warranty",
      url: "/base/WAR",
      icon: "icon-chart"
    },
    {
      name: "Waiting for parts",
      url: "/waiting-for-parts",
      icon: "icon-chart"
    },
    // {
    //   name: "Turn Around Time",
    //   url: "/base/TAT",
    //   icon: "icon-chart"
    // },
    // {
    //   name: "OEM Repair",
    //   url: "/base/OemRepair",
    //   icon: "icon-chart"
    // },
    // {
    //   title: true,
    //   name: "Summary report",
    //   class: "",
    //   wrapper: {
    //     element: "",
    //     attributes: {}
    //   }
    // },
    // {
    //   name: "Technical Reports",
    //   url: "/base/reports",
    //   icon: "icon-chart"
    // },
    {
      title: true,
      name: "Sales",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    },
    {
      name: "Sales Rep",
      url: "/base/SalesRep",
      icon: "icon-pencil"
    },
    {
      name: "Sales Map Overview",
      url: "/base/SalesMap",
      icon: "icon-map"
    },
    {
      title: true,
      name: "Issues",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    },
    {
      name: "Issues Preview",
      url: "/base/IssuesPreview",
      icon: "icon-pencil"
    },
    {
      name: "Issues Map Overview",
      url: "/base/IssuesMap",
      icon: "icon-map"
    }
    // {
    //   title: true,
    //   name: "Account",
    //   class: "",
    //   wrapper: {
    //     element: "",
    //     attributes: {}
    //   }
    // },
    // {
    //   name: 'Dashboard',
    //   url: '/stackedChart',
    //   icon: 'icon-speedometer',
    //   badge: {
    //     variant: 'primary',
    //     text: 'Example'
    //   },
    // },
    // {
    //   title: true,
    //   name: 'TOOLS',
    //   class: '',
    //   wrapper: {
    //     element: '',
    //     attributes: {}
    //   }
    // },
    // {
    //   name: 'Repaired Inventory',
    //   url: '/base',
    //   icon: 'icon-puzzle',
    //   children: [
    //     {
    //       name: 'Add New Item',
    //       url: '/base/AddNewItem',
    //       icon: 'icon-pencil'
    //     },
    //     {
    //       name: 'Inventory Report',
    //       url: '/base/inventory',
    //       icon: 'icon-puzzle'
    //     }
    //   ]
    // }
  ]
};
